import TopBar from "./components/TopBar";
import Navbar from "./components/Navbar";
import Hero from "./components/Hero";
import EntryStrip from "./components/EntryStrip";
import TimelineFeed from "./components/TimelineFeed";
import SectionGrid from "./components/SectionGrid";
import HotTopics from "./components/HotTopics";
import InsideFeed from "./components/InsideFeed";
import FaqTrust from "./components/FaqTrust";
import PostForm from "./components/PostForm";
import Footer from "./components/Footer";

export default function Home() {
  return (
    <div className="w-full bg-[#faf8f4]">
      <TopBar />
      <Navbar />
      <main>
        <Hero />
        <EntryStrip />
        <TimelineFeed />
        <SectionGrid />
        <HotTopics />
        <InsideFeed />
        <FaqTrust />
        <PostForm />
      </main>
      <Footer />
    </div>
  );
}